import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import { FAQS } from "@/constants/content";
import { HOME } from "@/constants/testIds";

const FAQ = () => (
  <section id="faq" className="section-pad relative">
    <div className="container-x">
      <div className="grid gap-10 lg:grid-cols-[0.9fr_1.3fr] items-start">
        <div>
          <div className="chip"><HelpCircle className="w-3 h-3" /> FAQ</div>
          <h2 className="mt-3 font-display font-bold tracking-tight text-slate-900" style={{ fontSize: "clamp(2rem, 4vw, 3.25rem)" }}>
            Everything you might be <span className="gradient-text-emerald">wondering</span>.
          </h2>
          <p className="mt-4 text-slate-600 max-w-md">
            Still not sure? Have a look — most people ask these before they reserve.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="rounded-3xl border border-slate-100 bg-white/90 shadow-premium overflow-hidden"
        >
          <Accordion type="single" collapsible defaultValue="q-0" className="divide-y divide-slate-100">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`q-${i}`}
                className="border-b-0"
              >
                <AccordionTrigger
                  data-testid={`${HOME.faqTrigger}-${i}`}
                  className="text-left px-5 sm:px-6 py-5 font-display font-semibold text-slate-900 text-base sm:text-lg hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="px-5 sm:px-6 pb-5 text-slate-600 text-sm sm:text-base leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </div>
  </section>
);

export default FAQ;
